// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/load.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { WeightDisplayUnit } from "./weight_display_unit_pb.js";
import { file_trade_v1_weight_display_unit } from "./weight_display_unit_pb.js";
import type { CurrencyCode, Decimal, ID, Money, Weight } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/load.proto.
 */
export const file_trade_v1_load: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_trade_v1_weight_display_unit, file_types]);

/**
 * Load represents a shipment load
 *
 * @generated from message trade.v1.Load
 */
export type Load = Message<"trade.v1.Load"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: trade.v1.LoadStatus status = 2;
   */
  status: LoadStatus;

  /**
   * @generated from field: string document_number = 3;
   */
  documentNumber: string;

  /**
   * @generated from field: google.protobuf.StringValue expected_ship_date = 4;
   */
  expectedShipDate?: string;

  /**
   * @generated from field: google.protobuf.Timestamp shipped_date = 5;
   */
  shippedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 6;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue description = 7;
   */
  description?: string;

  /**
   * @generated from field: types.Weight heavy_weight = 8;
   */
  heavyWeight?: Weight;

  /**
   * @generated from field: types.Weight light_weight = 9;
   */
  lightWeight?: Weight;

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 32;
   */
  weightDisplayUnit: WeightDisplayUnit;

  /**
   * @generated from field: repeated trade.v1.LoadLineItem line_items = 33;
   */
  lineItems: LoadLineItem[];

  /**
   * @generated from field: types.CurrencyCode currency_code = 35;
   */
  currencyCode: CurrencyCode;

  /**
   * Relationships
   *
   * @generated from field: google.protobuf.StringValue sales_order_id = 10;
   */
  salesOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue booking_id = 11;
   */
  bookingId?: string;

  /**
   * @generated from field: string facility_id = 12;
   */
  facilityId: string;

  /**
   * @generated from field: google.protobuf.StringValue container_type_id = 31;
   */
  containerTypeId?: string;

  /**
   * @generated from field: google.protobuf.StringValue brokered_order_id = 36;
   */
  brokeredOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue supplier_id = 37;
   */
  supplierId?: string;

  /**
   * @generated from field: google.protobuf.StringValue supplier_address_id = 38;
   */
  supplierAddressId?: string;

  /**
   * @generated from field: google.protobuf.StringValue outbound_tolling_agreement_id = 39;
   */
  outboundTollingAgreementId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_id = 40;
   */
  customerAccountId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_address_id = 42;
   */
  customerAccountAddressId?: string;

  /**
   * @generated from field: google.protobuf.StringValue receiving_facility_id = 41;
   */
  receivingFacilityId?: string;

  /**
   * Carrier & Freight
   *
   * @generated from field: google.protobuf.StringValue carrier_account_id = 43;
   */
  carrierAccountId?: string;

  /**
   * Shipping details
   *
   * @generated from field: google.protobuf.StringValue shipping_carrier_name = 13;
   */
  shippingCarrierName?: string;

  /**
   * @generated from field: google.protobuf.StringValue scac = 14;
   */
  scac?: string;

  /**
   * @generated from field: google.protobuf.StringValue freight_forwarder = 15;
   */
  freightForwarder?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_freight = 16;
   */
  truckFreight?: string;

  /**
   * @generated from field: google.protobuf.StringValue delivery_number = 17;
   */
  deliveryNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue release_number = 18;
   */
  releaseNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue driver_name = 19;
   */
  driverName?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_number = 20;
   */
  truckNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue trailer_number = 21;
   */
  trailerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue container_number = 22;
   */
  containerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue seal_number = 23;
   */
  sealNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_internal_notes = 24;
   */
  recyclerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_external_notes = 25;
   */
  recyclerExternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_internal_notes = 29;
   */
  customerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_external_notes = 30;
   */
  customerExternalNotes?: string;

  /**
   * Timestamps
   *
   * @generated from field: string organization_id = 26;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 27;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 28;
   */
  updatedAt?: Timestamp;

  /**
   * Custom attributes for extensibility and legacy system integration
   *
   * @generated from field: google.protobuf.Struct custom_attributes = 34;
   */
  customAttributes?: JsonObject;
};

/**
 * Describes the message trade.v1.Load.
 * Use `create(LoadSchema)` to create a new message.
 */
export const LoadSchema: GenMessage<Load> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 0);

/**
 * LoadLineItem represents a line item in a load
 *
 * @generated from message trade.v1.LoadLineItem
 */
export type LoadLineItem = Message<"trade.v1.LoadLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string load_id = 2;
   */
  loadId: string;

  /**
   * @generated from field: trade.v1.SalesItemLineType type = 3;
   */
  type: SalesItemLineType;

  /**
   * Item references
   *
   * @generated from field: google.protobuf.StringValue item_id = 4;
   */
  itemId?: string;

  /**
   * @generated from field: google.protobuf.StringValue tag_id = 5;
   */
  tagId?: string;

  /**
   * Phase indicates the stage of the line item (Requested, Staged, Shipped)
   *
   * @generated from field: google.protobuf.StringValue phase = 6;
   */
  phase?: string;

  /**
   * Purchase Order reference (for brokerage: which PO supplies this line item)
   *
   * @generated from field: google.protobuf.StringValue purchase_order_id = 17;
   */
  purchaseOrderId?: string;

  /**
   * Weights map - keys: "gross", "tare", "net", "quantityOwed"
   *
   * @generated from field: map<string, types.Weight> weights = 7;
   */
  weights: { [key: string]: Weight };

  /**
   * Pricing
   *
   * @generated from field: types.Money unit_price = 11;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money estimated_price = 12;
   */
  estimatedPrice?: Money;

  /**
   * @generated from field: string pricing_unit = 13;
   */
  pricingUnit: string;

  /**
   * Custom attributes for extensibility and legacy system integration
   *
   * @generated from field: google.protobuf.Struct custom_attributes = 16;
   */
  customAttributes?: JsonObject;
};

/**
 * Describes the message trade.v1.LoadLineItem.
 * Use `create(LoadLineItemSchema)` to create a new message.
 */
export const LoadLineItemSchema: GenMessage<LoadLineItem> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 1);

/**
 * Request/Response messages for Load operations
 *
 * @generated from message trade.v1.GetLoadRequest
 */
export type GetLoadRequest = Message<"trade.v1.GetLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message trade.v1.GetLoadRequest.
 * Use `create(GetLoadRequestSchema)` to create a new message.
 */
export const GetLoadRequestSchema: GenMessage<GetLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 2);

/**
 * @generated from message trade.v1.GetLoadResponse
 */
export type GetLoadResponse = Message<"trade.v1.GetLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.GetLoadResponse.
 * Use `create(GetLoadResponseSchema)` to create a new message.
 */
export const GetLoadResponseSchema: GenMessage<GetLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 3);

/**
 * @generated from message trade.v1.ListLoadsRequest
 */
export type ListLoadsRequest = Message<"trade.v1.ListLoadsRequest"> & {
  /**
   * @generated from field: trade.v1.ListLoadsFilter filter = 1;
   */
  filter?: ListLoadsFilter;

  /**
   * @generated from field: repeated trade.v1.LoadSortOption sorting = 2;
   */
  sorting: LoadSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message trade.v1.ListLoadsRequest.
 * Use `create(ListLoadsRequestSchema)` to create a new message.
 */
export const ListLoadsRequestSchema: GenMessage<ListLoadsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 4);

/**
 * @generated from message trade.v1.ListLoadsFilter
 */
export type ListLoadsFilter = Message<"trade.v1.ListLoadsFilter"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * @generated from field: repeated trade.v1.LoadStatus status = 2;
   */
  status: LoadStatus[];

  /**
   * @generated from field: google.protobuf.StringValue sales_order_id = 3;
   */
  salesOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue booking_id = 4;
   */
  bookingId?: string;

  /**
   * @generated from field: google.protobuf.StringValue facility_id = 5;
   */
  facilityId?: string;

  /**
   * @generated from field: google.protobuf.StringValue from_expected_ship_date = 6;
   */
  fromExpectedShipDate?: string;

  /**
   * @generated from field: google.protobuf.StringValue to_expected_ship_date = 7;
   */
  toExpectedShipDate?: string;

  /**
   * @generated from field: google.protobuf.StringValue from_shipped_date = 8;
   */
  fromShippedDate?: string;

  /**
   * @generated from field: google.protobuf.StringValue to_shipped_date = 9;
   */
  toShippedDate?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 10;
   */
  searchTerm?: string;

  /**
   * @generated from field: string organization_id = 11;
   */
  organizationId: string;

  /**
   * @generated from field: repeated types.ID created_by = 12;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 13;
   */
  updatedBy: ID[];
};

/**
 * Describes the message trade.v1.ListLoadsFilter.
 * Use `create(ListLoadsFilterSchema)` to create a new message.
 */
export const ListLoadsFilterSchema: GenMessage<ListLoadsFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 5);

/**
 * @generated from message trade.v1.ListLoadsResponse
 */
export type ListLoadsResponse = Message<"trade.v1.ListLoadsResponse"> & {
  /**
   * @generated from field: repeated trade.v1.Load loads = 1;
   */
  loads: Load[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message trade.v1.ListLoadsResponse.
 * Use `create(ListLoadsResponseSchema)` to create a new message.
 */
export const ListLoadsResponseSchema: GenMessage<ListLoadsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 6);

/**
 * Request message for checking search permissions on loads
 *
 * @generated from message trade.v1.CheckLoadSearchPermissionsRequest
 */
export type CheckLoadSearchPermissionsRequest = Message<"trade.v1.CheckLoadSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message trade.v1.CheckLoadSearchPermissionsRequest.
 * Use `create(CheckLoadSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckLoadSearchPermissionsRequestSchema: GenMessage<CheckLoadSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 7);

/**
 * Response message for the CheckSearchPermissions RPC
 *
 * @generated from message trade.v1.CheckLoadSearchPermissionsResponse
 */
export type CheckLoadSearchPermissionsResponse = Message<"trade.v1.CheckLoadSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string permitted_ids = 1;
   */
  permittedIds: string[];
};

/**
 * Describes the message trade.v1.CheckLoadSearchPermissionsResponse.
 * Use `create(CheckLoadSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckLoadSearchPermissionsResponseSchema: GenMessage<CheckLoadSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 8);

/**
 * Request message for getting LoadLineItems by custom attribute
 *
 * @generated from message trade.v1.GetLoadLineItemsByCustomAttributeRequest
 */
export type GetLoadLineItemsByCustomAttributeRequest = Message<"trade.v1.GetLoadLineItemsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated google.protobuf.Value attribute_values = 2;
   */
  attributeValues: Value[];

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.GetLoadLineItemsByCustomAttributeRequest.
 * Use `create(GetLoadLineItemsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetLoadLineItemsByCustomAttributeRequestSchema: GenMessage<GetLoadLineItemsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 9);

/**
 * Response message for getting LoadLineItems by custom attribute
 *
 * @generated from message trade.v1.GetLoadLineItemsByCustomAttributeResponse
 */
export type GetLoadLineItemsByCustomAttributeResponse = Message<"trade.v1.GetLoadLineItemsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated trade.v1.LoadLineItem line_items = 1;
   */
  lineItems: LoadLineItem[];
};

/**
 * Describes the message trade.v1.GetLoadLineItemsByCustomAttributeResponse.
 * Use `create(GetLoadLineItemsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetLoadLineItemsByCustomAttributeResponseSchema: GenMessage<GetLoadLineItemsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 10);

/**
 * Command messages
 *
 * @generated from message trade.v1.CreateLoadRequest
 */
export type CreateLoadRequest = Message<"trade.v1.CreateLoadRequest"> & {
  /**
   * @generated from field: trade.v1.LoadInput input = 1;
   */
  input?: LoadInput;

  /**
   * @generated from field: repeated trade.v1.LoadLineItemInput line_items = 2;
   */
  lineItems: LoadLineItemInput[];

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.CreateLoadRequest.
 * Use `create(CreateLoadRequestSchema)` to create a new message.
 */
export const CreateLoadRequestSchema: GenMessage<CreateLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 11);

/**
 * @generated from message trade.v1.CreateLoadResponse
 */
export type CreateLoadResponse = Message<"trade.v1.CreateLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.CreateLoadResponse.
 * Use `create(CreateLoadResponseSchema)` to create a new message.
 */
export const CreateLoadResponseSchema: GenMessage<CreateLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 12);

/**
 * @generated from message trade.v1.UpdateLoadRequest
 */
export type UpdateLoadRequest = Message<"trade.v1.UpdateLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: trade.v1.LoadUpdateInput input = 2;
   */
  input?: LoadUpdateInput;

  /**
   * @generated from field: repeated trade.v1.LoadLineItemInput line_items = 3;
   */
  lineItems: LoadLineItemInput[];

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.UpdateLoadRequest.
 * Use `create(UpdateLoadRequestSchema)` to create a new message.
 */
export const UpdateLoadRequestSchema: GenMessage<UpdateLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 13);

/**
 * @generated from message trade.v1.UpdateLoadResponse
 */
export type UpdateLoadResponse = Message<"trade.v1.UpdateLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.UpdateLoadResponse.
 * Use `create(UpdateLoadResponseSchema)` to create a new message.
 */
export const UpdateLoadResponseSchema: GenMessage<UpdateLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 14);

/**
 * @generated from message trade.v1.DeleteLoadRequest
 */
export type DeleteLoadRequest = Message<"trade.v1.DeleteLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.DeleteLoadRequest.
 * Use `create(DeleteLoadRequestSchema)` to create a new message.
 */
export const DeleteLoadRequestSchema: GenMessage<DeleteLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 15);

/**
 * @generated from message trade.v1.DeleteLoadResponse
 */
export type DeleteLoadResponse = Message<"trade.v1.DeleteLoadResponse"> & {
};

/**
 * Describes the message trade.v1.DeleteLoadResponse.
 * Use `create(DeleteLoadResponseSchema)` to create a new message.
 */
export const DeleteLoadResponseSchema: GenMessage<DeleteLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 16);

/**
 * @generated from message trade.v1.AssignLoadRequest
 */
export type AssignLoadRequest = Message<"trade.v1.AssignLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.AssignLoadRequest.
 * Use `create(AssignLoadRequestSchema)` to create a new message.
 */
export const AssignLoadRequestSchema: GenMessage<AssignLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 17);

/**
 * @generated from message trade.v1.AssignLoadResponse
 */
export type AssignLoadResponse = Message<"trade.v1.AssignLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.AssignLoadResponse.
 * Use `create(AssignLoadResponseSchema)` to create a new message.
 */
export const AssignLoadResponseSchema: GenMessage<AssignLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 18);

/**
 * @generated from message trade.v1.ShipLoadRequest
 */
export type ShipLoadRequest = Message<"trade.v1.ShipLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp shipped_date = 2;
   */
  shippedDate?: Timestamp;

  /**
   * @generated from field: types.Weight light_weight = 3;
   */
  lightWeight?: Weight;

  /**
   * @generated from field: types.Weight heavy_weight = 4;
   */
  heavyWeight?: Weight;

  /**
   * @generated from field: string organization_id = 5;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.ShipLoadRequest.
 * Use `create(ShipLoadRequestSchema)` to create a new message.
 */
export const ShipLoadRequestSchema: GenMessage<ShipLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 19);

/**
 * @generated from message trade.v1.ShipLoadResponse
 */
export type ShipLoadResponse = Message<"trade.v1.ShipLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.ShipLoadResponse.
 * Use `create(ShipLoadResponseSchema)` to create a new message.
 */
export const ShipLoadResponseSchema: GenMessage<ShipLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 20);

/**
 * @generated from message trade.v1.ReconcileLoadRequest
 */
export type ReconcileLoadRequest = Message<"trade.v1.ReconcileLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated trade.v1.LoadLineItemReconcileInput items = 2;
   */
  items: LoadLineItemReconcileInput[];

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 4;
   */
  invoiceId: string;
};

/**
 * Describes the message trade.v1.ReconcileLoadRequest.
 * Use `create(ReconcileLoadRequestSchema)` to create a new message.
 */
export const ReconcileLoadRequestSchema: GenMessage<ReconcileLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 21);

/**
 * @generated from message trade.v1.ReconcileLoadResponse
 */
export type ReconcileLoadResponse = Message<"trade.v1.ReconcileLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.ReconcileLoadResponse.
 * Use `create(ReconcileLoadResponseSchema)` to create a new message.
 */
export const ReconcileLoadResponseSchema: GenMessage<ReconcileLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 22);

/**
 * @generated from message trade.v1.VoidLoadRequest
 */
export type VoidLoadRequest = Message<"trade.v1.VoidLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string void_reason = 3;
   */
  voidReason: string;
};

/**
 * Describes the message trade.v1.VoidLoadRequest.
 * Use `create(VoidLoadRequestSchema)` to create a new message.
 */
export const VoidLoadRequestSchema: GenMessage<VoidLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 23);

/**
 * @generated from message trade.v1.VoidLoadResponse
 */
export type VoidLoadResponse = Message<"trade.v1.VoidLoadResponse"> & {
};

/**
 * Describes the message trade.v1.VoidLoadResponse.
 * Use `create(VoidLoadResponseSchema)` to create a new message.
 */
export const VoidLoadResponseSchema: GenMessage<VoidLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 24);

/**
 * @generated from message trade.v1.RevertLoadStatusRequest
 */
export type RevertLoadStatusRequest = Message<"trade.v1.RevertLoadStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: trade.v1.LoadStatus target_status = 2;
   */
  targetStatus: LoadStatus;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.RevertLoadStatusRequest.
 * Use `create(RevertLoadStatusRequestSchema)` to create a new message.
 */
export const RevertLoadStatusRequestSchema: GenMessage<RevertLoadStatusRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 25);

/**
 * @generated from message trade.v1.RevertLoadStatusResponse
 */
export type RevertLoadStatusResponse = Message<"trade.v1.RevertLoadStatusResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.RevertLoadStatusResponse.
 * Use `create(RevertLoadStatusResponseSchema)` to create a new message.
 */
export const RevertLoadStatusResponseSchema: GenMessage<RevertLoadStatusResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 26);

/**
 * @generated from message trade.v1.ReceiveLoadRequest
 */
export type ReceiveLoadRequest = Message<"trade.v1.ReceiveLoadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 2;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: repeated trade.v1.ReceivedLineItemInput received_line_items = 3;
   */
  receivedLineItems: ReceivedLineItemInput[];

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.ReceiveLoadRequest.
 * Use `create(ReceiveLoadRequestSchema)` to create a new message.
 */
export const ReceiveLoadRequestSchema: GenMessage<ReceiveLoadRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 27);

/**
 * @generated from message trade.v1.ReceiveLoadResponse
 */
export type ReceiveLoadResponse = Message<"trade.v1.ReceiveLoadResponse"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.ReceiveLoadResponse.
 * Use `create(ReceiveLoadResponseSchema)` to create a new message.
 */
export const ReceiveLoadResponseSchema: GenMessage<ReceiveLoadResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 28);

/**
 * Input messages
 *
 * @generated from message trade.v1.LoadInput
 */
export type LoadInput = Message<"trade.v1.LoadInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue expected_ship_date = 1;
   */
  expectedShipDate?: string;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 2;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue description = 3;
   */
  description?: string;

  /**
   * @generated from field: types.Weight heavy_weight = 4;
   */
  heavyWeight?: Weight;

  /**
   * @generated from field: types.Weight light_weight = 5;
   */
  lightWeight?: Weight;

  /**
   * @generated from field: google.protobuf.StringValue sales_order_id = 6;
   */
  salesOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue booking_id = 7;
   */
  bookingId?: string;

  /**
   * @generated from field: string facility_id = 8;
   */
  facilityId: string;

  /**
   * @generated from field: google.protobuf.StringValue shipping_carrier_name = 9;
   */
  shippingCarrierName?: string;

  /**
   * @generated from field: google.protobuf.StringValue scac = 10;
   */
  scac?: string;

  /**
   * @generated from field: google.protobuf.StringValue freight_forwarder = 11;
   */
  freightForwarder?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_freight = 12;
   */
  truckFreight?: string;

  /**
   * @generated from field: google.protobuf.StringValue delivery_number = 13;
   */
  deliveryNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue release_number = 14;
   */
  releaseNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue driver_name = 15;
   */
  driverName?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_number = 16;
   */
  truckNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue trailer_number = 17;
   */
  trailerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue container_number = 18;
   */
  containerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue seal_number = 19;
   */
  sealNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_internal_notes = 20;
   */
  recyclerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_external_notes = 21;
   */
  recyclerExternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_internal_notes = 22;
   */
  customerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_external_notes = 23;
   */
  customerExternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue container_type_id = 24;
   */
  containerTypeId?: string;

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 25;
   */
  weightDisplayUnit: WeightDisplayUnit;

  /**
   * @generated from field: google.protobuf.StringValue outbound_tolling_agreement_id = 26;
   */
  outboundTollingAgreementId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_id = 27;
   */
  customerAccountId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_address_id = 29;
   */
  customerAccountAddressId?: string;

  /**
   * @generated from field: google.protobuf.StringValue receiving_facility_id = 28;
   */
  receivingFacilityId?: string;
};

/**
 * Describes the message trade.v1.LoadInput.
 * Use `create(LoadInputSchema)` to create a new message.
 */
export const LoadInputSchema: GenMessage<LoadInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 29);

/**
 * @generated from message trade.v1.LoadUpdateInput
 */
export type LoadUpdateInput = Message<"trade.v1.LoadUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue expected_ship_date = 1;
   */
  expectedShipDate?: string;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 2;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue description = 3;
   */
  description?: string;

  /**
   * @generated from field: types.Weight heavy_weight = 4;
   */
  heavyWeight?: Weight;

  /**
   * @generated from field: types.Weight light_weight = 5;
   */
  lightWeight?: Weight;

  /**
   * @generated from field: google.protobuf.StringValue facility_id = 6;
   */
  facilityId?: string;

  /**
   * @generated from field: google.protobuf.StringValue booking_id = 7;
   */
  bookingId?: string;

  /**
   * @generated from field: google.protobuf.StringValue sales_order_id = 8;
   */
  salesOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue shipping_carrier_name = 9;
   */
  shippingCarrierName?: string;

  /**
   * @generated from field: google.protobuf.StringValue scac = 10;
   */
  scac?: string;

  /**
   * @generated from field: google.protobuf.StringValue freight_forwarder = 11;
   */
  freightForwarder?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_freight = 12;
   */
  truckFreight?: string;

  /**
   * @generated from field: google.protobuf.StringValue delivery_number = 13;
   */
  deliveryNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue release_number = 14;
   */
  releaseNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue driver_name = 15;
   */
  driverName?: string;

  /**
   * @generated from field: google.protobuf.StringValue truck_number = 16;
   */
  truckNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue trailer_number = 17;
   */
  trailerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue container_number = 18;
   */
  containerNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue seal_number = 19;
   */
  sealNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_internal_notes = 20;
   */
  recyclerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue recycler_external_notes = 21;
   */
  recyclerExternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_internal_notes = 22;
   */
  customerInternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_external_notes = 23;
   */
  customerExternalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue container_type_id = 24;
   */
  containerTypeId?: string;

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 25;
   */
  weightDisplayUnit: WeightDisplayUnit;

  /**
   * @generated from field: google.protobuf.StringValue outbound_tolling_agreement_id = 26;
   */
  outboundTollingAgreementId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_id = 27;
   */
  customerAccountId?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_account_address_id = 29;
   */
  customerAccountAddressId?: string;

  /**
   * @generated from field: google.protobuf.StringValue receiving_facility_id = 28;
   */
  receivingFacilityId?: string;
};

/**
 * Describes the message trade.v1.LoadUpdateInput.
 * Use `create(LoadUpdateInputSchema)` to create a new message.
 */
export const LoadUpdateInputSchema: GenMessage<LoadUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 30);

/**
 * @generated from message trade.v1.LoadLineItemInput
 */
export type LoadLineItemInput = Message<"trade.v1.LoadLineItemInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue id = 1;
   */
  id?: string;

  /**
   * @generated from field: trade.v1.SalesItemLineType type = 2;
   */
  type: SalesItemLineType;

  /**
   * @generated from field: google.protobuf.StringValue item_id = 3;
   */
  itemId?: string;

  /**
   * @generated from field: google.protobuf.StringValue tag_id = 4;
   */
  tagId?: string;

  /**
   * Weights map - keys: "gross", "tare", "net", "quantityOwed"
   *
   * @generated from field: map<string, types.Weight> weights = 6;
   */
  weights: { [key: string]: Weight };

  /**
   * @generated from field: types.Money unit_price = 10;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money estimated_price = 11;
   */
  estimatedPrice?: Money;

  /**
   * @generated from field: string pricing_unit = 12;
   */
  pricingUnit: string;
};

/**
 * Describes the message trade.v1.LoadLineItemInput.
 * Use `create(LoadLineItemInputSchema)` to create a new message.
 */
export const LoadLineItemInputSchema: GenMessage<LoadLineItemInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 31);

/**
 * @generated from message trade.v1.LoadLineItemReconcileInput
 */
export type LoadLineItemReconcileInput = Message<"trade.v1.LoadLineItemReconcileInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: types.Decimal shipped_quantity = 2;
   */
  shippedQuantity?: Decimal;

  /**
   * @generated from field: types.Weight shipped_weight = 3;
   */
  shippedWeight?: Weight;
};

/**
 * Describes the message trade.v1.LoadLineItemReconcileInput.
 * Use `create(LoadLineItemReconcileInputSchema)` to create a new message.
 */
export const LoadLineItemReconcileInputSchema: GenMessage<LoadLineItemReconcileInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 32);

/**
 * @generated from message trade.v1.ReceivedLineItemInput
 */
export type ReceivedLineItemInput = Message<"trade.v1.ReceivedLineItemInput"> & {
  /**
   * @generated from field: string load_line_item_id = 1;
   */
  loadLineItemId: string;

  /**
   * @generated from field: string material_type = 2;
   */
  materialType: string;

  /**
   * @generated from field: types.Decimal gross_quantity = 3;
   */
  grossQuantity?: Decimal;

  /**
   * @generated from field: types.Decimal tare_quantity = 4;
   */
  tareQuantity?: Decimal;

  /**
   * @generated from field: types.Money unit_price = 5;
   */
  unitPrice?: Money;

  /**
   * @generated from field: google.protobuf.StringValue notes = 6;
   */
  notes?: string;

  /**
   * @generated from field: string pricing_unit = 7;
   */
  pricingUnit: string;
};

/**
 * Describes the message trade.v1.ReceivedLineItemInput.
 * Use `create(ReceivedLineItemInputSchema)` to create a new message.
 */
export const ReceivedLineItemInputSchema: GenMessage<ReceivedLineItemInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_load, 33);

/**
 * LoadStatus enum
 *
 * @generated from enum trade.v1.LoadStatus
 */
export enum LoadStatus {
  /**
   * @generated from enum value: LOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOAD_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: LOAD_STATUS_RECONCILED = 2;
   */
  RECONCILED = 2,

  /**
   * @generated from enum value: LOAD_STATUS_SHIPPED = 3;
   */
  SHIPPED = 3,

  /**
   * @generated from enum value: LOAD_STATUS_RECEIVED = 4;
   */
  RECEIVED = 4,

  /**
   * @generated from enum value: LOAD_STATUS_UNASSIGNED = 5;
   */
  UNASSIGNED = 5,

  /**
   * @generated from enum value: LOAD_STATUS_VOIDED = 6;
   */
  VOIDED = 6,
}

/**
 * Describes the enum trade.v1.LoadStatus.
 */
export const LoadStatusSchema: GenEnum<LoadStatus> = /*@__PURE__*/
  enumDesc(file_trade_v1_load, 0);

/**
 * SalesItemLineType enum
 *
 * @generated from enum trade.v1.SalesItemLineType
 */
export enum SalesItemLineType {
  /**
   * @generated from enum value: SALES_ITEM_LINE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SALES_ITEM_LINE_TYPE_RAW = 1;
   */
  RAW = 1,

  /**
   * @generated from enum value: SALES_ITEM_LINE_TYPE_TAGGED = 2;
   */
  TAGGED = 2,
}

/**
 * Describes the enum trade.v1.SalesItemLineType.
 */
export const SalesItemLineTypeSchema: GenEnum<SalesItemLineType> = /*@__PURE__*/
  enumDesc(file_trade_v1_load, 1);

/**
 * @generated from enum trade.v1.LoadSortOption
 */
export enum LoadSortOption {
  /**
   * @generated from enum value: LOAD_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_STATUS_ASC = 1;
   */
  STATUS_ASC = 1,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_STATUS_DESC = 2;
   */
  STATUS_DESC = 2,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_EXPECTED_SHIP_DATE_ASC = 3;
   */
  EXPECTED_SHIP_DATE_ASC = 3,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_EXPECTED_SHIP_DATE_DESC = 4;
   */
  EXPECTED_SHIP_DATE_DESC = 4,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_SHIPPED_DATE_ASC = 5;
   */
  SHIPPED_DATE_ASC = 5,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_SHIPPED_DATE_DESC = 6;
   */
  SHIPPED_DATE_DESC = 6,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_CREATED_AT_ASC = 7;
   */
  CREATED_AT_ASC = 7,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_CREATED_AT_DESC = 8;
   */
  CREATED_AT_DESC = 8,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_UPDATED_AT_ASC = 9;
   */
  UPDATED_AT_ASC = 9,

  /**
   * @generated from enum value: LOAD_SORT_OPTION_UPDATED_AT_DESC = 10;
   */
  UPDATED_AT_DESC = 10,
}

/**
 * Describes the enum trade.v1.LoadSortOption.
 */
export const LoadSortOptionSchema: GenEnum<LoadSortOption> = /*@__PURE__*/
  enumDesc(file_trade_v1_load, 2);

/**
 * Services
 *
 * @generated from service trade.v1.LoadQueriesService
 */
export const LoadQueriesService: GenService<{
  /**
   * @generated from rpc trade.v1.LoadQueriesService.GetLoad
   */
  getLoad: {
    methodKind: "unary";
    input: typeof GetLoadRequestSchema;
    output: typeof GetLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadQueriesService.ListLoads
   */
  listLoads: {
    methodKind: "unary";
    input: typeof ListLoadsRequestSchema;
    output: typeof ListLoadsResponseSchema;
  },
  /**
   * CheckSearchPermissions checks which of the provided load IDs the user has permission to access
   *
   * @generated from rpc trade.v1.LoadQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckLoadSearchPermissionsRequestSchema;
    output: typeof CheckLoadSearchPermissionsResponseSchema;
  },
  /**
   * GetLoadLineItemsByCustomAttribute retrieves load line items by custom attribute
   *
   * @generated from rpc trade.v1.LoadQueriesService.GetLoadLineItemsByCustomAttribute
   */
  getLoadLineItemsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetLoadLineItemsByCustomAttributeRequestSchema;
    output: typeof GetLoadLineItemsByCustomAttributeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_load, 0);

/**
 * @generated from service trade.v1.LoadCommandsService
 */
export const LoadCommandsService: GenService<{
  /**
   * @generated from rpc trade.v1.LoadCommandsService.CreateLoad
   */
  createLoad: {
    methodKind: "unary";
    input: typeof CreateLoadRequestSchema;
    output: typeof CreateLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.UpdateLoad
   */
  updateLoad: {
    methodKind: "unary";
    input: typeof UpdateLoadRequestSchema;
    output: typeof UpdateLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.DeleteLoad
   */
  deleteLoad: {
    methodKind: "unary";
    input: typeof DeleteLoadRequestSchema;
    output: typeof DeleteLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.AssignLoad
   */
  assignLoad: {
    methodKind: "unary";
    input: typeof AssignLoadRequestSchema;
    output: typeof AssignLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.ShipLoad
   */
  shipLoad: {
    methodKind: "unary";
    input: typeof ShipLoadRequestSchema;
    output: typeof ShipLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.ReceiveLoad
   */
  receiveLoad: {
    methodKind: "unary";
    input: typeof ReceiveLoadRequestSchema;
    output: typeof ReceiveLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.ReconcileLoad
   */
  reconcileLoad: {
    methodKind: "unary";
    input: typeof ReconcileLoadRequestSchema;
    output: typeof ReconcileLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.VoidLoad
   */
  voidLoad: {
    methodKind: "unary";
    input: typeof VoidLoadRequestSchema;
    output: typeof VoidLoadResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.LoadCommandsService.RevertLoadStatus
   */
  revertLoadStatus: {
    methodKind: "unary";
    input: typeof RevertLoadStatusRequestSchema;
    output: typeof RevertLoadStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_load, 1);

